module.exports = __webpack_public_path__ + "img/zhengtai.29bde608.png";